export const enum FeatureFlagEnum {
  UpcCodeFieldEnabledInOrderRequestForm = 'isUpcCodeFieldEnabledInOrderRequestForm',
  WebsiteFieldEnabledInOrderRequestForm = 'isWebsiteFieldEnabledInOrderRequestForm',
  ImageFieldEnabledInOrderRequestForm = 'isImageFieldEnabledInOrderRequestForm',
  DescriptionFieldEnabledInOrderRequestForm = 'isDescriptionFieldEnabledInOrderRequestForm',
  ProjectFieldEnabledInOrderRequestForm = 'isProjectFieldEnabledInOrderRequestForm',
  CustomLabelField = 'isCustomLabelFieldEnable',
}
